import { useFetchBondRequestPreviews } from "@portal/api/previews";
import { FilterableDataTable } from "@portal/components/ui/FilterableDataTable";
import { useIsMinimalBondUIEnabled } from "@portal/hooks/useIsMinimalBondUIEnabled";
import { FC, useMemo } from "react";
import { getRequestsTableColumns } from "./columns";

export const BondRequestPreviewsAll: FC = () => {
	const { bondRequestPreviews } = useFetchBondRequestPreviews();
	const isMinimalUIEnabled = useIsMinimalBondUIEnabled();

	const allBondRequestPreviews = useMemo(() => {
		if (!bondRequestPreviews) return undefined;
		return [...bondRequestPreviews];
	}, [bondRequestPreviews]);

	const columns = useMemo(() => getRequestsTableColumns(isMinimalUIEnabled), [isMinimalUIEnabled]);

	return (
		<FilterableDataTable
			name="bond_requests_v2"
			columnDefs={columns}
			getRowUrl={(row) => `/accounts/${row.accountId}/requests/${row.id}`}
			data={allBondRequestPreviews}
			loadingMessage="Loading bond requests..."
			enableExportToCSV
		/>
	);
};
